import { ScenarioFeedProgram } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-feed-program.type';

export enum ScenarioHarvestTargetType {
  WEEK = 'Week',
  WEIGHT = 'Weight',
}

export interface ScenarioCageData {
  id: string;
  fetchedAt: string;
  fishCount: number;
  fishGroupId: string;
  fishGroupName: string;
  harvestTarget: number;
  harvestTargetType: ScenarioHarvestTargetType;
  isIncluded: boolean;
  isUserEdited: boolean;
  isVirtual: boolean;
  meanWeight: number;
  seaCloudLastUpdated: string;
  startDate: string;
  stockingDate: string;
  estimatedHarvestDate: string;
  unitName: string;
  feedProgram: ScenarioFeedProgram;
  mortalityProfileId: number;
  mortalityProfileName: string;
}
